import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-d120c440"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "core-advant"
};
const _hoisted_2 = {
  class: "tit"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, null, -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, null, -1));

const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = {
  class: "right-adv"
};
const _hoisted_8 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createTextVNode(" " + _toDisplayString(_ctx.companyData.name) + " ", 1), _hoisted_4]), _createElementVNode("p", {
    innerHTML: _ctx.companyData.content
  }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CoreAdv, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(_ctx.flag ? 'bigDiv' : 'smallDiv')
    }, [_createElementVNode("p", null, _toDisplayString(item.name), 1), _createElementVNode("span", {
      innerHTML: item.content
    }, null, 8, _hoisted_8)], 2);
  }), 256))])])]);
}